class CustomTypeaheadController {

    /***
     * Callback function for when a typeahead item is selected.
     *
     * @param item      the selected item
     */
    onSelect(item) {
        this.onItemSelect({item: item});
        if (this.clearAfterSelect) {
            this.selectedDisplay = null;
        }
    }

}

export default CustomTypeaheadController;


// WEBPACK FOOTER //
// ./app/common/custom-typeahead/custom-typeahead-controller.js